import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';

const JourneySection = ({ 
  title, 
  description, 
  image, 
  imageAlt, 
  features = [],
  customClass = '' 
}) => {
  return (
    <section className={`py-16 px-4 bg-white ${customClass}`}>
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="order-2 lg:order-1">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              {parse(title.split(' - ')[0]) + ' - '}<span className="font-light">{parse(title.split(' - ')[1])}</span>
            </h2>
            <div className="text-lg text-gray-700 mb-8 space-y-4">
              {Array.isArray(description) ? (
                description.map((paragraph, index) => (
                  <p key={index}>{parse(paragraph)}</p>
                ))
              ) : (
                <p>{parse(description)}</p>
              )}
            </div>
            
            {features.length > 0 && (
              <div className="space-y-4 pl-5">
                {features.map((feature, index) => (
                  <div key={index} className="flex items-start space-x-3">
                    <div className="flex flex-row items-start gap-1">
                     <span><li /></span>
                      <div>
                        <span className="font-semibold text-gray-900 mb-1">{feature.title}</span><span className="text-gray-600 font-normal">{parse(feature.description)}</span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
          
          <div className="order-1 lg:order-2">
            <img 
              src={image} 
              alt={imageAlt}
              className="w-full h-auto rounded-lg shadow-lg"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

JourneySection.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]).isRequired,
  image: PropTypes.string.isRequired,
  imageAlt: PropTypes.string.isRequired,
  features: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired
  })),
  customClass: PropTypes.string
};

export default JourneySection;